import Vue from 'vue'

let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  top1: '概览',
  top2: '技术规格',
  // dec: '高度360°全景云台，便携耐用，操作简单',
  yushou: '【New Product Presale Price】',
  price: 'USD 209',
  buy: 'Buy it on Alibaba',
  cart: '加入购物车',
  tiaokuan: '',
  guige: {
    name: 'Technical Specifications',
    dec: [
      '* Due to the influence of ambient light, monitor color difference, flashing, etc., there might be a certain color deviation on the color of the product. Please be aware of that.'
    ],
    arr: [
      {
        name: 'Model',
        val: ['Tripod ET1004 + Ball Head Y-10']
      },
      {
        name: 'Product',
        val: ['Y-10 Series Aluminum Alloy Counter-foldable Tripod Set']
      },
      {
        name: 'Weight',
        val: ['1.59 KG incl. tripod head. (The weight of the tripod head is 0.37 KG)']
      },
      {
        name: 'Ball Head Model',
        val: [
          'Y-10'
        ]
      },
      {
        name: 'Material',
        val: [
          'Aluminium Alloy'
        ]
      },
      {
        name: 'Leg Diameter',
        val: [
          '25mm Thick, 16mm Thin'
        ]
      },
      {
        name: 'Leg Section',
        val: [
          '4 Sections'
        ]
      },
      {
        name: 'Carrying Capacity',
        val: [
          '8KG'
        ]
      },
      {
        name: 'Folded Height',
        val: [
          '56cm'
        ]
      },
      {
        name: 'Low angle',
        val: [
          '21.5cm'
        ]
      },
      {
        name: 'Extended Height',
        val: [
          'Height with center column dropped down: 123.5cm Max. Height: 156.5cm (incl. ball head, ball head height: 8.8cm)'
        ]
      },
      {
        name: 'Equipped with',
        val: [
          'Packing box, tripod bag, tripod set, short centre column, bag strap, 4 hex wrenches, certificate, manual.'
        ]
      }
    ]
  },
  lunguige: {
    name: 'Specifications',
    dec: 'Note: All configurations and specifications listed on this page shall prevail the actural product launched to the market, and are subject to alteration without notice.',
    arr: [
      {
        name: 'Roller model',
        val: ['B900']
      },
      {
        name: 'Min. length',
        val: ['30cm']
      },
      {
        name: 'Max. length',
        val: ['43cm']
      },
      {
        name: 'Min. distance',
        val: [
          '56cm'
        ]
      },
      {
        name: 'Max. distance',
        val: [
          '78cm'
        ]
      },
      {
        name: 'Folded length',
        val: [
          '43cm'
        ]
      },
      {
        name: 'Material',
        val: [
          '6063T5 Aluminum Alloy ABS'
        ]
      },
      {
        name: 'Colour',
        val: [
          'Black'
        ]
      },
      {
        name: 'Carrying Capacity',
        val: [
          '15kg'
        ]
      },
      {
        name: 'Leg Segments',
        val: [
          '2'
        ]
      },
      {
        name: 'Net Weight',
        val: [
          '1.7kg'
        ]
      },
      {
        name: 'Lock type',
        val: [
          'Plate buckle'
        ]
      },
      {
        name: 'Roller wheel diameter',
        val: [
          '5cm'
        ]
      },
      {
        name: 'Accessories',
        val: [
          'Roller wheels, carrying backpack.'
        ]
      }
    ]
  },
  color: {
    key: 'Colour',
    val: 'Standard colour'
  },
  service: {
    type: '',
    key: 'Accessories',
    val: [
      'Tripod Model: ET1004',
      'Quick Release Plate Model: Y-10',
      'Tripod Wheel Model: B900'
    ],
    peijian: '了解详细参数'
  },
  count: {
    key: 'Amount'
  },
  zhijia: {
    name: 'Professional Tripod System',
    sub: 'Forged with aluminum alloy, balancing both portability and endurance',
    detail: 'Details',
    detailArr: [
      {
        name: '360°swivel Tripod Ball Head',
        img: `${baseUrl}images/zhijia-detail01.png`
      },
      {
        name: 'Multi-Angle Adjustment Leg Locks',
        img: `${baseUrl}images/zhijia-detail02.png`
      },
      {
        name: 'Safe Center Column Twist Lock',
        img: `${baseUrl}images/zhijia-detail03.png`
      },
      {
        name: 'Anti-Slip NBR Foam Grips',
        img: `${baseUrl}images/zhijia-detail04.png`
      },
      {
        name: 'Retractable Weigh Hook',
        img: `${baseUrl}images/zhijia-detail05.png`
      },
      {
        name: 'Aluminium Leg with Buckle Lock',
        img: `${baseUrl}images/zhijia-detail06.png`
      }
    ]
  },
  hualun: {
    name: 'Professional Tripod Roller',
    sub: 'Stable and Reliable, Smooth to Operate'
  }
}



// WEBPACK FOOTER //
// ./src/store/language/en/purchasezhijia.js